import { jsx as n, jsxs as x } from "react/jsx-runtime";
import { Children as C, cloneElement as b } from "react";
import { f as w } from "../../../index-CZ8zjHGv.js";
import "styled-components";
import { useThemeInMode as S } from "../../../context/theme/hooks.js";
import v from "../../../styles/shadows/useShadow.js";
import k from "../../../utils/isTouchDevice.js";
import "../../layout/Stack/Stack.js";
import m from "../../layout/Box/Box.js";
import "../../layout/Center/Center.js";
import "../../../context/WindowSize/Dimensions.js";
import "lodash-es";
import "../../layout/Columns/ColumnsContext.js";
import y from "../components/ContextPopup/ContextPopup.js";
import P from "../components/PopupArrow/PopupArrow.js";
function K({
  tooltip: r,
  children: o,
  closeDelay: t = 0,
  position: l = "top",
  contrast: u = "low",
  showArrow: a,
  maxWidth: c = "400px",
  anchorWidth: s,
  anchorHeight: h,
  boundingElementRef: d,
  enabled: i = !0
}) {
  const { backgroundColor: e, color: p, boxShadow: f } = A(u);
  return /* @__PURE__ */ n(
    y,
    {
      position: l,
      hover: !k(),
      closeDelay: t,
      anchorWidth: s,
      anchorHeight: h,
      boundingElementRef: d,
      enablePopup: i,
      children: {
        anchor: ({ anchorProps: g }) => C.toArray(w(o)).length === 1 ? b(o, {
          ...g,
          cursor: i && "help"
        }) : (console.error("A tooltip must have one child"), o),
        popup: () => /* @__PURE__ */ x(m, { display: "flex", alignItems: "center", position: "relative", children: [
          /* @__PURE__ */ n(
            m,
            {
              backgroundColor: e,
              color: p,
              padding: "large",
              borderRadius: "small",
              maxWidth: c,
              boxShadow: f,
              allChildrenStyles: {
                color: `${p} !important`,
                backgroundColor: `${e} !important`
              },
              children: r
            }
          ),
          a && /* @__PURE__ */ n(P, { position: l, color: e })
        ] })
      }
    }
  );
}
function A(r) {
  const o = S(), t = v("small");
  return r === "low" ? {
    backgroundColor: o.foreground,
    color: o["neutral-high-content"],
    boxShadow: t
  } : {
    backgroundColor: o["neutral-high-surface"],
    color: o["contentOn-neutral-high-surface"],
    boxShadow: void 0
  };
}
export {
  K as default
};
